module.exports = __webpack_public_path__ + "static/018.thumb-bac942f8966250ce998d88ea39efa457.jpg";